import * as React from 'react'

import Image from 'next/legacy/image'

export const nextImageLoader = (src, width, originalWidth) => {
  let resizedWidth = originalWidth < width ? originalWidth : width
  return `${src}?fm=jpg&fl=progressive&w=${resizedWidth}`
}

/** @type {import("./types").default} */
const NextImage = ({ alt, src: srcProp, width: originalWidth, ...props }) => (
  <Image
    alt={alt}
    loader={({ src, width }) => nextImageLoader(src, width, originalWidth)}
    src={srcProp}
    objectFit="cover"
    layout="responsive"
    width={originalWidth}
    {...props}
  />
)

export default NextImage
